export default __webpack_public_path__ + "static/media/clock.e9ab9b22.svg";